/* eslint-disable id-blacklist */
import { IModel } from './models';
import { PageAction } from '../models';

export type HttpResponseType = 'arraybuffer' | 'blob' | 'json' | 'text';

export interface TableCustomButton {
  label?: string;
  pageAction?: PageAction;
  show: boolean;
}

export interface Table {
  tableId?: string;
  type: string;
  customButton?: TableCustomButton;
  actions: string[];
  hasBulkActions?: boolean;
  showBulkActionsButton?: boolean;
  disableBulkActions?: boolean;
  showBulkSaveButton?: boolean;
  showToggleButton?: boolean;
  showNewButton?: boolean;
  isLoading?: boolean;
  newButtonLabel?: string;
  items: IModel[];
  labelText?: string;
  checkboxLimit?: number;
  showFilterList?: boolean;
  showSearchbar?: boolean;
  saveButtonText?: string;
}

export enum ColumnType {
  number = 'number',
  string = 'string',
  telephone = 'telephone',
  date = 'date',
  option = 'option',
  boolean = 'boolean',
  array = 'array',
  link = 'link',
  raw = 'raw',
}

export enum FeatureType {
  territory = 'territory',
  grid = 'grid',
  walklist = 'walklist',
}

export enum FilterTypes {
  unit = 'unit',
  unitOverviewLabel = 'ENABLED',
}

/**
 * this is used to identify
 * the different models created
 * and also for the menu
 */
export enum PageTitles {
  // VENDOR PAGE
  vendor = 'vendor',
  vendorGroup = 'group', //'teams', //'group'
  vendorSalesRep = 'sales-rep', //'team-sales-rep', //'sales-rep'
  // CPMS (Striker) entities
  cpmsOutlet = 'cpms-outlet',
  cpmsSalesRep = 'cpms-sales-rep',
  // APP CONFIG
  appConfig = 'app-config',
  systemConfig = 'system-config',
  value = 'values',
  // TERRITORY & WALKLIST
  territoryWalklist = 'territory-walklist',
  territory = 'territory',
  territoryFsa = 'territory-fsa',
  fsa = 'fsa',
  activityAddress = 'activity-address' /* shared element */,
  addressWalklist = 'addresswalklist',
  walklistldps = 'walklist-lpds',
  walklist = 'walklist',
  dropWalklist = 'drop-walklist',
  salesWalklist = 'sales-walklist',
  // ADDRESS 360
  ams = 'ams-service',
  address360 = 'address360',
  addressActivity = 'address-activity',
  addressHistory = 'address-history',
  // MENU
  menu = 'menu',
  // INTEL
  intel = 'intel',
  drop = 'drop-permission',
  dropTableView = 'drop-permission-view',
  knock = 'knock-list',
  knockDetails = 'knock-list-details',
  knockTableView = 'knock-list-view',
  sales = 'sales',
  assignment = 'special-event-assignment',
  specialEvent = 'special-event',
  privilege = 'privilege',
  role = 'role',
  user = 'user',
  roleUser = 'role-user',
  attachment = 'attachment',
  team = 'team',
  globalSearch = 'search',
  permission = 'permission',
  entitlement = 'entitlement',
  fsaAssignment = 'fsaAssignment',
  d2cgeo = 'd2cgeo',
  d2cgeofeaturesproperties = 'd2cgeofeaturesproperties',
  d2Cgeoserviceaddress = 'd2Cgeoserviceaddress',

  //Territory Phase 2
  territoryCreation = 'territory-creation',
  territoryManagement = 'territory-management',
  territoryWalklistCreation = 'territory-walklist-creation',
  territoryWalklistAssigment = 'territory-walklist-assigment',
  featureCollection = 'feature-collection',
  walklistAddressSequence = 'walklist-address-sequence',
}

/**
 * this is used by the language service
 * to do translation by page
 */
export enum LanguagePage {
  // VENDOR PAGE
  vendorGroupSales = 'VendorGroupSalesPage',
  vendorGroup = 'TeamPage',
  vendorSalesRep = 'TeamSalesRepPage',
  // CPMS (Striker) entities
  cpmsOutlet = 'CPMSOutletPage',
  cpmsSalesRep = 'CPMSSalesRepPage',
  // APP CONFIG
  appConfig = 'AppConfigPage',
  systemConfig = 'SystemConfigPage',
  value = 'ValuePage',
  // TERRITORY & WALKLIST
  territoryWalklist = 'TerritoryWalklistPage',
  territory = 'TerritoryPage',
  territoryDetails = 'TerritoryDetailsPage',
  fsa = 'FsaPage',
  activityAddress = 'ActivityAddressPage',
  addressWalklist = 'AddressWalklistPage',
  walkListDetailsPage = 'WalkListDetailsPage',
  walklist = 'WalklistPage',
  // ADDRESS 360
  address360 = 'AddressPage',
  addressHistory = 'AddressHistoryPage',
  searchAddress360 = 'SearchAddress360Page',
  // MENU
  menu = 'MenuPage',
  // INTEL
  intel = 'IntelPage',
  drop = 'Drop-PermissionPage',
  knock = 'Knock-ListPage',
  sales = 'SalesPage',
  assignment = 'Special-Event-AssignmentPage',
  specialEvent = 'SpecialEventPage',
  userManagement = 'UserManagementPage',
  user = 'UserPage',
  role = 'RolePage',
  roleUser = 'RoleUserPage',
  attachment = 'AttachmentPage',
  login = 'Login',
  privilege = 'PrivilegePage',
  fsaAssignment = 'fsaAssignment',
  d2cgeo = 'd2cgeo',
  globalSearch = 'search',

  territorycreation = 'TerritoryCreationPage',
  territorymanagement = 'TerritoryManagementPage',
  territorymanagementV2 = 'tableV2',
  territorywalklistcreation = 'TerritoryWalklistCreationPage',
  territorywalklistassigment = 'TerritoryWalklistAssigment',
  walklistAddressSequence = 'walklist-address-sequence',
}

// eslint-disable-next-line @typescript-eslint/naming-convention
export enum actions {
  create,
  update,
  delete,
  softDelete,
}
